import {
  Input,
  NumberInput,
  NumberInputField,
  Select,
  Td, Text, Tooltip,
  Tr
} from "@chakra-ui/react";
import { GroupBase, Select as AutoComplete } from "chakra-react-select";
import { ClientClassificationType } from "models/client_classification_type";
import { OrderCategoryItem } from "models/order_category_item";
import { ProdutoItemType } from "models/product_item_type";
import { ProductType } from "models/product_type";
import { OptionType } from "models/select_mode";
import { useEffect, useState } from "react";
import formatNumber from "views/admin/order/hooks/formatNumber";
interface IOrderItemRow {
  item1: OrderCategoryItem;
  index1: number;
  index: number;
  produtos: ProductType[];
  unidades: ClientClassificationType[];
}

const ItemTableRow = ({
  item1,
  index1,
  index,
  produtos,
  unidades,
}: IOrderItemRow) => {

  const [descricao, setDescricao] = useState("");
  const [unidade, setUnidade] = useState("");
  const [quantidade, setQuantidade] = useState("1");
  const [valor, setValor] = useState("");
  const [total, setTotal] = useState(0);
  const [selectedProdutoItens, setSelectedProdutoItens] =
    useState<ProdutoItemType>();

  const [unidadesDisponiveis, setUnidadesDisponiveis] = useState<
    ClientClassificationType[]
  >([]);

  useEffect(() => {
    if (item1) {
      setDescricao(item1.descricao);
      setUnidade(item1.unidadeMedidaId);
      setQuantidade(Number(item1.quantidade).toFixed(2));
      setValor(Number(item1.valorUn).toFixed(2));
      setTotal(item1.valorTotal);
      const prdUn = produtos?.find((value) => value.id === item1.produtoId);
      const unDisp: ClientClassificationType[] = [];
      unidades?.forEach((v) => {
        const existe = prdUn?.ProdutoUnidade.find(
          (un) => un.unidadeMedidaId === v.id
        );
        if (existe) {
          unDisp.push(v);
          if (existe.principal) {
            const selected = prdUn?.ProdutoUnidade.find(
              (prd) => prd?.unidadeMedidaId === existe.unidadeMedidaId
            );
            if (selected) {
              setSelectedProdutoItens(selected);
            }
          }
        }
      });

      setUnidadesDisponiveis(unDisp);
    }

  }, [item1, produtos, unidades]);

  return (
    <Tr>
      <Td width={24}>
        {" "}
        {index + 1}. {index1 + 1}
      </Td>
      <Td width={450}>
        {" "}
        <AutoComplete<OptionType, false, GroupBase<OptionType>>
          size="md"
          placeholder="Buscar..."
          name={"Produto"}
          options={produtos?.map((item) => {
            return {
              label: item?.nome,
              value: item?.id,
            };
          })}
          value={{
            label: produtos?.find((val) => val?.id === item1?.produtoId)?.nome,
            value: produtos?.find((val) => val?.id === item1?.produtoId)?.id,
          }}
        />
      </Td>
      <Td>
        {" "}
        <Input
          isRequired={false}
          fontSize="sm"
          value={descricao}
          ms={{ base: "0px", md: "0px" }}
          type="text"
          placeholder="Digite a Descrição"
          fontWeight="500"
          name={`descricao--${index1}-${descricao}`}
          border={"none"}
          size="md"
        />
      </Td>
      <Td width={300}>
        <Select
          size="md"
          defaultValue={unidade}
          name={`unidade-${index1}-${index}`}
        >
          {unidadesDisponiveis.map((item) => (
            <option value={item?.id}>{item?.nome}</option>
          ))}
        </Select>
      </Td>
      <Td>
        {" "}
        <NumberInput
          precision={2}
          step={1}
          min={1}
          name={`quantidade--${index1}-${quantidade}`}
          value={quantidade}
        >
          <NumberInputField />
        </NumberInput>
      </Td>
      <Td>
        {" "}
        <Tooltip
          label={`O valor deve ser entre ${formatNumber(
            isNaN(Number(selectedProdutoItens?.valorMin))
              ? 0
              : formatNumber(Number(selectedProdutoItens?.valorMin))
          )} e ${formatNumber(
            isNaN(Number(selectedProdutoItens?.valorMax))
              ? 0
              : formatNumber(Number(selectedProdutoItens?.valorMax))
          )}`}
        >
          <NumberInput
            precision={2}
            name={`valor--${index1}-${valor}`}
            value={valor}
          >
            <NumberInputField />
          </NumberInput>
        </Tooltip>
      </Td>
      <Td><Text
              textAlign="left"
              color={"black"}
              fontSize={14}
              alignSelf={"center"}
              width={150}
            >
             {formatNumber(Number(total))}
            </Text></Td>

    </Tr>
  );
};
export default ItemTableRow;
